import type { User } from '@/domain/User';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface DoctorPatientRelation {
  id: number;
  doctor_id: number;
  user_id?: number;
  patient_id?: number;
  doctor?: User;
  patient?: User;
}

export interface DoctorPatientsResponse {
  data: Array<DoctorPatientRelation>;
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface DoctorPatientsFilters {
  [key: string]: string | number | undefined;
  doctor_id?: number;
  user_id?: number;
  per_page?: number;
}

export const getDoctorPatientsQuery = (filters: DoctorPatientsFilters) =>
  queryOptions({
    queryKey: queryKeys.doctorPatients.all(filters),
    queryFn: async (): Promise<DoctorPatientsResponse> => {
      const searchParams = new URLSearchParams();
      if (filters.doctor_id)
        searchParams.set('doctor_id', String(filters.doctor_id));
      if (filters.user_id) searchParams.set('user_id', String(filters.user_id));
      if (filters.per_page)
        searchParams.set('per_page', String(filters.per_page));

      return await api
        .get(`admin/doctor-patients?${searchParams.toString()}`)
        .json<DoctorPatientsResponse>();
    },
  });
